
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('nos') && (binding.modules['nos'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos' */
            '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/adventureworks'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','carousel','cart-icon','checkout-section-container','content-block','navigation-menu','search-result-container','search'],
        iNM: true,
        ns: '__local__',
        n: 'nos',
        p: '__local__',
        
        pdp: 'node_modules/@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/adventureworks.definition.json',
        
        themeSettings: 'nos.theme.settings.json',
        md: 'src/themes/nos'
    });
        

    isNotRegistered('nos-account-profile') && (binding.modules['nos-account-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-account-profile' */
            'partner/modules/nos-account-profile/nos-account-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-account-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-account-profile'
    });
        

    isNotRegistered('nos-anchor') && (binding.modules['nos-anchor'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-anchor' */
            'partner/modules/nos-anchor/nos-anchor.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-anchor',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-anchor'
    });
        

    isNotRegistered('nos-business-sign-up') && (binding.modules['nos-business-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-business-sign-up' */
            'partner/modules/nos-business-sign-up/nos-business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-business-sign-up'
    });
        

    isNotRegistered('nos-checkout-guest-profile') && (binding.modules['nos-checkout-guest-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-checkout-guest-profile' */
            'partner/modules/nos-checkout-guest-profile/nos-checkout-guest-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-checkout-guest-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-checkout-guest-profile'
    });
        

    isNotRegistered('nos-companytype-picker') && (binding.modules['nos-companytype-picker'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-companytype-picker' */
            'partner/modules/nos-companytype-picker/nos-companytype-picker.tsx'),
        $type: 'contentModule',
        da: [{name:'availableCompanyTypes',  path:'actions/get-available-company-types.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-companytype-picker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-companytype-picker'
    });
        

    isNotRegistered('nos-country-picker') && (binding.modules['nos-country-picker'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-country-picker' */
            'partner/modules/nos-country-picker/nos-country-picker.tsx'),
        $type: 'contentModule',
        da: [{name:'availableCountries',  path:'actions/get-available-countries.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-country-picker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-country-picker'
    });
        

    isNotRegistered('nos-customer-account-payment') && (binding.modules['nos-customer-account-payment'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-customer-account-payment' */
            'partner/modules/nos-customer-account-payment/nos-customer-account-payment.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-customer-account-payment',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-customer-account-payment'
    });
        

    isNotRegistered('nos-header') && (binding.modules['nos-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-header' */
            'partner/modules/nos-header/nos-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-header'
    });
        

    isNotRegistered('nos-image') && (binding.modules['nos-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-image' */
            'partner/modules/nos-image/nos-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-image'
    });
        

    isNotRegistered('nos-invoice-details') && (binding.modules['nos-invoice-details'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-invoice-details' */
            'partner/modules/nos-invoice-details/nos-invoice-details.tsx'),
        $type: 'contentModule',
        da: [{name:'invoice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice', runOn: 0},{name:'invoiceDetails',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-invoice-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-invoice-details'
    });
        

    isNotRegistered('nos-invoices-list') && (binding.modules['nos-invoices-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-invoices-list' */
            'partner/modules/nos-invoices-list/nos-invoices-list.tsx'),
        $type: 'contentModule',
        da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-invoices-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-invoices-list'
    });
        

    isNotRegistered('nos-key-facts') && (binding.modules['nos-key-facts'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-key-facts' */
            'partner/modules/nos-key-facts/nos-key-facts.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-key-facts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-key-facts'
    });
        

    isNotRegistered('nos-language-picker') && (binding.modules['nos-language-picker'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-language-picker' */
            'partner/modules/nos-language-picker/nos-language-picker.tsx'),
        $type: 'contentModule',
        da: [{name:'availableLanguages',  path:'actions/get-available-languages.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-language-picker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-language-picker'
    });
        

    isNotRegistered('nos-link-list') && (binding.modules['nos-link-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-link-list' */
            'partner/modules/nos-link-list/nos-link-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-link-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-link-list'
    });
        

    isNotRegistered('nos-origin-of-interest-picker') && (binding.modules['nos-origin-of-interest-picker'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-origin-of-interest-picker' */
            'partner/modules/nos-origin-of-interest-picker/nos-origin-of-interest-picker.tsx'),
        $type: 'contentModule',
        da: [{name:'customerSources',  path:'actions/get-customer-sources.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-origin-of-interest-picker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-origin-of-interest-picker'
    });
        

    isNotRegistered('nos-payment-instrument') && (binding.modules['nos-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-payment-instrument' */
            'partner/modules/nos-payment-instrument/nos-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/nos-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-payment-instrument'
    });
        

    isNotRegistered('nos-phone-picker') && (binding.modules['nos-phone-picker'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-phone-picker' */
            'partner/modules/nos-phone-picker/nos-phone-picker.tsx'),
        $type: 'contentModule',
        da: [{name:'availableCountries',  path:'actions/get-available-countries.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-phone-picker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-phone-picker'
    });
        

    isNotRegistered('nos-referral-registration') && (binding.modules['nos-referral-registration'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-referral-registration' */
            'partner/modules/nos-referral-registration/nos-referral-registration.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-referral-registration',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-referral-registration'
    });
        

    isNotRegistered('nos-sign-up') && (binding.modules['nos-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-sign-up' */
            'partner/modules/nos-sign-up/nos-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-sign-up'
    });
        

    isNotRegistered('nos-subscription-details') && (binding.modules['nos-subscription-details'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-subscription-details' */
            'partner/modules/nos-subscription-details/nos-subscription-details.tsx'),
        $type: 'contentModule',
        da: [{name:'subscriptiondetails',  path:'actions/get-subscription-details.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-subscription-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-subscription-details'
    });
        

    isNotRegistered('nos-subscription-list') && (binding.modules['nos-subscription-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-subscription-list' */
            'partner/modules/nos-subscription-list/nos-subscription-list.tsx'),
        $type: 'contentModule',
        da: [{name:'subscriptionList',  path:'actions/get-subscription-list.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-subscription-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-subscription-list'
    });
        

    isNotRegistered('nos-text-block') && (binding.modules['nos-text-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nos-text-block' */
            'partner/modules/nos-text-block/nos-text-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'nos-text-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/nos-text-block'
    });
        

        {   
            const actionPath = 'actions/cancel-subscription.action';
            binding.dataActions[actionPath] = require('partner/actions/cancel-subscription.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/change-customer-reference.action';
            binding.dataActions[actionPath] = require('partner/actions/change-customer-reference.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-active-prices-hook.action';
            binding.dataActions[actionPath] = require('partner/actions/get-active-prices-hook.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-address-suggestion.action';
            binding.dataActions[actionPath] = require('partner/actions/get-address-suggestion.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-available-company-types.action';
            binding.dataActions[actionPath] = require('partner/actions/get-available-company-types.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-available-countries.action';
            binding.dataActions[actionPath] = require('partner/actions/get-available-countries.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-available-languages.action';
            binding.dataActions[actionPath] = require('partner/actions/get-available-languages.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-customer-sources.action';
            binding.dataActions[actionPath] = require('partner/actions/get-customer-sources.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-graduated-price.action';
            binding.dataActions[actionPath] = require('partner/actions/get-graduated-price.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-subscription-details.action';
            binding.dataActions[actionPath] = require('partner/actions/get-subscription-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-subscription-list.action';
            binding.dataActions[actionPath] = require('partner/actions/get-subscription-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/validate-email-code.action';
            binding.dataActions[actionPath] = require('partner/actions/validate-email-code.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/validate-vat.action';
            binding.dataActions[actionPath] = require('partner/actions/validate-vat.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/verify-email.action';
            binding.dataActions[actionPath] = require('partner/actions/verify-email.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('nos-account-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-account-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-companytype-picker')){
            const sanitizedActionPath = 'actions/get-available-company-types.action';
            let dataAction = require('partner/actions/get-available-company-types.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-country-picker')){
            const sanitizedActionPath = 'actions/get-available-countries.action';
            let dataAction = require('partner/actions/get-available-countries.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoice-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoice-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-language-picker')){
            const sanitizedActionPath = 'actions/get-available-languages.action';
            let dataAction = require('partner/actions/get-available-languages.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-origin-of-interest-picker')){
            const sanitizedActionPath = 'actions/get-customer-sources.action';
            let dataAction = require('partner/actions/get-customer-sources.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-payment-instrument')){
            const sanitizedActionPath = 'modules/nos-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/nos-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-phone-picker')){
            const sanitizedActionPath = 'actions/get-available-countries.action';
            let dataAction = require('partner/actions/get-available-countries.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-subscription-details')){
            const sanitizedActionPath = 'actions/get-subscription-details.action';
            let dataAction = require('partner/actions/get-subscription-details.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('nos-subscription-list')){
            const sanitizedActionPath = 'actions/get-subscription-list.action';
            let dataAction = require('partner/actions/get-subscription-list.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};